// Material
import { Stack, Typography, ListItem, ListItemAvatar } from '@mui/material'
import { styled } from '@mui/material/styles'
import { TextWithSkeleton } from '$common/text-with-skeleton'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { showImageViewerModal } from '$comp/modals/image-viewer'
import { AvatarBase } from '$common/avatar/avatar-base'
import { getAvatarText } from '$func/avatar-text'
import { ReactNode } from 'react'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const InfoContainer = styled(Stack)`
  width: 100%;
  justify-content: center;
  margin-right: 15px;
  overflow: hidden;
`

const StyledListItem = styled(ListItem)`
  box-sizing: border-box;
  padding: 7px 8px 8px 0;
`

const StyledSecondaryText = styled(Typography)`
  opacity: 0.9;
`

interface Props {
  avatarElement: ReactNode
  avatarSrc: string
  primaryText: string
  secondaryText: string | number | JSX.Element
  hasDeleted?: boolean
  avatarBackground?: string
  squareMode?: boolean
  backgroundColor?: string
}

export function RoomProfileHeaderInfo({
  avatarElement,
  avatarSrc,
  primaryText,
  secondaryText,
  hasDeleted = false,
  avatarBackground,
  squareMode = false,
  backgroundColor,
}: Props) {
  // TODO: CHECK IF SKELETON IS NEEDED OR NOT
  // return <Skeleton variant="text" />

  return (
    // TODO: REPLACE AVATAR WITH SPECIAL AVATAR COMPONENT IN COMMON
    <StyledListItem>
      <ListItemAvatar>
        {avatarElement ? (
          avatarElement
        ) : (
          <AvatarBase
            src={avatarSrc}
            size={AvatarSize.XL}
            backgroundColor={avatarBackground}
            hasDeleted={hasDeleted}
            onClick={() => {
              if (avatarSrc) showImageViewerModal({ media: { src: avatarSrc } })
            }}
            sx={{
              cursor: avatarSrc ? 'pointer' : 'unset',
            }}
          >
            {hasDeleted ? <RemovePersonIcon /> : getAvatarText(primaryText)}
          </AvatarBase>
        )}
      </ListItemAvatar>
      <InfoContainer>
        <TextWithSkeleton text={primaryText}>
          <Typography
            variant="subtitle1"
            component="div"
            color="inherit"
            mb="4px"
            noWrap
          >
            {primaryText}
          </Typography>
        </TextWithSkeleton>
        {typeof secondaryText === 'string' ||
        typeof secondaryText === 'number' ? (
          <TextWithSkeleton text={`${secondaryText}`}>
            <StyledSecondaryText
              variant="caption1"
              color={backgroundColor ? 'neutral000' : 'neutral600'}
            >
              {secondaryText}
            </StyledSecondaryText>
          </TextWithSkeleton>
        ) : (
          secondaryText
        )}
      </InfoContainer>
    </StyledListItem>
  )
}
